import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'sc-chatbot-answer-custom',
  template: `
    <ng-container *ngComponentOutlet="dynamicComponent"></ng-container>
  `,
  //imports: [CommonModule]
})
export class AnswerCustomComponent {

  @Input() template!: string;
  dynamicComponent: any;

  ngOnInit() {
    this.dynamicComponent = Component({template: this.template})(class {});
  }
}